import { render, staticRenderFns } from "./AttachmentsShow.vue?vue&type=template&id=1f871b78&"
import script from "./AttachmentsShow.vue?vue&type=script&lang=js&"
export * from "./AttachmentsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports